import { Select, message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  SET_OUT_REFILLS,
  UPDATE_OUT_REFILLS,
} from "../../ActionTypes/ActionTypes";
import CarefillLists from "./CarefillLists";
import DispatchSearchForm from "./DispatchSearchForm";

const { Option } = Select;

class DispatchingSystemLandingPage extends Component {
  state = {
    loading: false,
    edit_refill_id: "",
    status: "",
    delivery_date: "",
  };

  componentDidMount = () => {
    const { setRefills } = this.props;

    this.setState({ loading: true });
    axios({
      method: "get",
      url: "/carefills/carefills_by_carefill_status.json?status=1",
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
    }).then((response) => {
      console.log(response.data);
      setRefills(response.data.carefills);
      this.setState({
        loading: false,
      });
    });
  };

  onDispatchEdit = (record) => {
    this.setState({
      edit_refill_id: record.id,
      status: Number(record.status),
      delivery_date: record.delivery_date,
    });
  };

  onStatusChange = (value) => {
    this.setState({
      status: value,
    });
  };

  onDeliveryDateChange = async (date, dateString) => {
    await this.setState({
      delivery_date: dateString,
    });
  };

  onDispatchSave = (record) => {
    const { refills, updateRefills } = this.props;
    const { status } = this.state;

    const indexAt = refills.indexOf(record);

    const values = { ...record };
    values.status = status;
    // values.delivery_date = deliveryDate;

    console.log(values, indexAt);

    this.setState({ loading: true });
    axios({
      method: "put",
      url: `/carefills/${Number(record.id)}.json`,
      headers: { Authorization: sessionStorage.getItem("jwtToken") },
      data: {
        carefill: {
          carefill_status: status,
        },
      },
    }).then((resp) => {
      console.log(resp.data);
      updateRefills(indexAt, values);
      this.setState({ loading: false });
    });

    this.setState(
      {
        edit_refill_id: "",
        status: "",
        delivery_date: "",
      },
      () => {
        updateRefills(indexAt, values);
        message.success("Updated Successfully!");
      }
    );
  };

  render() {
    const { refills } = this.props;
    const { edit_refill_id, loading, delivery_date, status } = this.state;

    const deliveryDetails = [
      { key: 1, value: "Inventorized" },
      { key: 2, value: "To Partner" },
      { key: 3, value: "To Patient" },
      { key: 4, value: "Courier" },
    ];

    const deliveryDetailsOptions = deliveryDetails.map((del) => (
      <Option key={del.key} value={del.key}>
        {del.value}
      </Option>
    ));

    return (
      <div>
        <div style={{ textAlign: "center" }}>
          <h2>Dispatching System</h2>
          <hr width="300" />
        </div>

        <DispatchSearchForm />

        <CarefillLists
          refills={refills}
          loading={loading}
          edit_refill_id={edit_refill_id}
          deliveryDate={delivery_date}
          status={status}
          deliveryDetailsOptions={deliveryDetailsOptions}
          onDeliveryDateChange={this.onDeliveryDateChange}
          onStatusChange={this.onStatusChange}
          onDispatchEdit={this.onDispatchEdit}
          onDispatchSave={this.onDispatchSave}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  refills: state.DispatchState.refills,
});

const mapDispatchToProps = (dispatch) => ({
  setRefills: (data) => dispatch({ type: SET_OUT_REFILLS, payload: { data } }),
  updateRefills: (id, data) =>
    dispatch({ type: UPDATE_OUT_REFILLS, payload: { id, data } }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatchingSystemLandingPage);



// WEBPACK FOOTER //
// ./src/component/DispatchingSystem/DispatchingSystemLandingPage.js